import * as React from 'react'

import { Tooltip, } from '../../../../Shared';

interface TruncatedDescriptionProps {
  description: string;
}

const TruncatedDescription: React.FC<TruncatedDescriptionProps> = ({ description }) => {
  const textRef = React.useRef<HTMLParagraphElement>(null);
  const [isTruncated, setIsTruncated] = React.useState(false);

  React.useEffect(() => {
    const element = textRef.current;
    if (!element) return;

    const checkTruncation = () => {
      if (element.clientHeight > 0) {
        setIsTruncated(element.scrollHeight > element.clientHeight);
      }
    };

    // Wait for next frame to ensure layout is complete
    const frameId = requestAnimationFrame(checkTruncation);

    // Also listen for resize events
    window.addEventListener('resize', checkTruncation);

    return () => {
      cancelAnimationFrame(frameId);
      window.removeEventListener('resize', checkTruncation);
    };
  }, [description]);

  const descriptionElement = (
    <p className="standard-description" ref={textRef}>{description}</p>
  );

  if (isTruncated) {
    return (
      <Tooltip
        tooltipText={description}
        tooltipTriggerText={descriptionElement}
      />
    );
  }

  return descriptionElement;
};

export default TruncatedDescription
